import TrackerDataTableView from '@/applications/scrum/components/TrackerDataTable/TrackerDataTableView/TrackerDataTableView.js'
import DeliveryGroup from '@/applications/sales/components/Delivery/DeliveryGroup/DeliveryGroup.vue'
import DeliveryGroupV2 from '@/applications/sales/components/Delivery/DeliveryGroupV2/DeliveryGroupV2.vue'
import DeliveryPayment from '@/applications/sales/components/Delivery/DeliveryPayment/DeliveryPayment.vue'
import DeliveryExecution from '@/applications/sales/components/Delivery/DeliveryExecution/DeliveryExecution.vue'

import authorizationMixin from '@/agilis/components/DataTableV2/common/authorizationMixin'

import { mapGetters } from 'vuex'

export default {
  name: 'DeliveryTableItemView',
  mixins: [TrackerDataTableView, authorizationMixin],

  components: {
    DeliveryExecution,
    DeliveryGroup,
    DeliveryGroupV2,
    DeliveryPayment
  },

  data () {
    return {
      mode: 'select',
      wpGroupItems: [],
      wpGroupItemsSpendingCap: [],
      wpGroupData: {},
      wpGroupDataSpendingCap: {},
      legacyGroups: false
    }
  },

  computed: {
    ...mapGetters({
      userIsAdmin: 'userDataStore/userIsAdmin'
    })
  },

  methods: {
    requestWpGroupItemsReload (_wpGroupItems) {
      if (_wpGroupItems.length > 0) {
        this.legacyGroups = true
        this.wpGroupItems = _wpGroupItems
      } else {
        this.legacyGroups = false
      }
    },

    requestWp3GroupItemsReload (_wpGroupItems) {
      if (_wpGroupItems.length > 0) {
        this.legacyGroups = false
        this.wpGroupItems = _wpGroupItems
      } else {
        this.legacyGroups = true
      }
    },

    requestWp3GroupItemsSpendingCapReload (_wpGroupItemsSpendingCap) {
      if (_wpGroupItemsSpendingCap.length > 0) {
        this.legacyGroups = false
        this.wpGroupItemsSpendingCap = _wpGroupItemsSpendingCap
      } else {
        this.legacyGroups = true
      }
    },

    requestWpGroupDataReload (wpGroupData) {
      this.wpGroupData = wpGroupData
    },

    requestWpGroupDataSpendingCapReload (wpGroupDataSpendingCap) {
      this.wpGroupDataSpendingCap = wpGroupDataSpendingCap
    }
  }
}
